import * as React from 'react';
const SvgChevronDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m15.857 10.35-.7-.7a.5.5 0 0 0-.7 0l-2.453 2.46L9.55 9.65c-.2-.2-.51-.2-.7 0l-.7.7c-.201.19-.201.51 0 .7l3.152 3.16c.39.39 1.011.39 1.401 0l3.153-3.16a.5.5 0 0 0 0-.7"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronDown;
